import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {WHITE} from 'ui-library/Colors';

import {PermissionsGraphQL} from './ReviewConstants';
import ReviewLifecycleSummaryPanel from './ReviewLifecycleSummaryPanel';

const menuStyles = StyleSheet.create({
  menu: {
    backgroundColor: WHITE,
    borderRadius: 4,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
    marginTop: 3,
    padding: 14,
    position: 'absolute',
    zIndex: 1000, // Keep in sync with zindex-dropdown in `less/bootstrap/variables.less`
    minWidth: 200,
    top: '100%',
    overflow: 'scroll',
    right: 0,
  },
});

export interface ReviewSummaryPanelMenuProps {
  permissions: PermissionsGraphQL;
}

export function ReviewSummaryPanelMenu({permissions}: ReviewSummaryPanelMenuProps): JSX.Element {
  return (
    <div className={css(menuStyles.menu)}>
      <ReviewLifecycleSummaryPanel permissions={permissions} />
    </div>
  );
}

export default ReviewSummaryPanelMenu;
